import { render, staticRenderFns } from "./RolesModalForm.vue?vue&type=template&id=dece8908"
import script from "./RolesModalForm.vue?vue&type=script&lang=js"
export * from "./RolesModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports